import React from "react";

import WeiterZoomen from "../components/cover/animations/weiterzoomen";
import background from '@cover/weiterzoomen/background-1.jpg';
import backgroundSm from '@cover/weiterzoomen/background-1-sm.jpg';
import background2 from '@cover/weiterzoomen/background-2.svg';
import bingoSrc from '@assets/zoom_bingo.svg';

export const meta = {
	category: "continue",
	slug: "zoomen",
	id: "WeiterZoomen",
	name: "weiterzoomen",
	title: "Heute schon gezoomt?",
	excerpt: {
		before: "Ein Zoom Meeting gleicht dem anderen? Bingo!"
	},
	animation: WeiterZoomen,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		layers: [
			{
				src: {
					lg: background2,
					sm: background2
				},
				zIndex: 666,
			}
		],
		alt: "Eine Frau sitzt in Pyjamahosen und Socken am Schreibtisch und nimmt an einem Video-Call teil. Eine Katze sitzt neben ihr auf dem Tisch, aus den Nebenzimmern kommen Geräusche von einem kleinen Mädchen und einem Baby."
	}
}

const WeiterzoomenArticle = () => {
	return (
		<div>
			<img className="articleContentImage" src={bingoSrc} />
		</div>
	)
};

export default WeiterzoomenArticle;